import {
	Component,
	Input
} from '@angular/core';

import { VideogularComponent } from '../Videogular.Component';

@Component({
	selector: 'vg-seek',
	template: `
		@if (isBackward || (!isBackward && !vgApi.seek10SecondsForwardDisabledSignal())) {
			<button
				type="button"
				[attr.aria-label]="isBackward ? translations.skipBack10Sec : translations.skipForward10Sec"
				[ngClass]="[
					'button',
					'vb-icon',
					isBackward ? 'vb-icon-backward-10' : 'vb-icon-forward-10'
				]"
				[tooltip]="isBackward ? translations.skipBack10Sec : translations.skipForward10Sec"
				[placement]="'top'"
				vbControlBarFocus
				[disableControlBarFocus]="disableControlBarFocus"
				(click)="vgApi.seek10Secs(!isBackward)">
			</button>
		}
	`,
	standalone: false,
	styleUrls: ['./VgSeek.Component.ng.less']
})
export class VgSeekComponent {
	@Input() public translations: any;
	@Input() public isBackward: boolean;
	@Input() public disableControlBarFocus: boolean;

	constructor(
		public vgApi: VideogularComponent
	) {}
}
